export default __webpack_public_path__ + "static/media/dino_panel.cbf24422.png";